import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import { IncomeDepositEvidencePanel } from './IncomeDepositEvidencePanel';
import type { IncomeDepositPanelData } from '../../lib/incomeDepositPanelData';
import type { IncomeStreamAccentMap } from '../../lib/incomeStreamPresentation';
import { messageFromOrchestratorAxiosError } from '../../lib/axiosErrorMessage';
import { ApplicationSectionCard } from '../application/applicationSectionChrome';
import type { IncomeSubTarget } from '../../lib/loanReview/mapLoanReviewToViewModel';

export function ApplicationIncomeBankActivityPanel({
  isPending,
  isError,
  error,
  depositData,
  streamAccentMap,
  incomeJump,
}: {
  isPending: boolean;
  isError: boolean;
  error: unknown;
  depositData: IncomeDepositPanelData | null;
  streamAccentMap?: IncomeStreamAccentMap;
  incomeJump?: { target: IncomeSubTarget; nonce: number } | null;
}) {
  return (
    <ApplicationSectionCard
      title="Bank activity"
      subtitle="Credits used for income, excluded credits, and bank debits from the same feed."
      icon={<AccountBalanceRoundedIcon fontSize="small" />}
      data-testid="income-bank-activity-panel"
    >
      {isPending ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress size={28} />
        </Box>
      ) : null}
      {isError ? (
        <Alert severity="error">
          {messageFromOrchestratorAxiosError(error) || 'Could not load bank activity.'}
        </Alert>
      ) : null}
      {!isPending && !isError && depositData ? (
        <IncomeDepositEvidencePanel
          data={depositData}
          variant="embedded"
          initialView="IN_MONTHLY_INCOME"
          streamAccentMap={streamAccentMap}
          incomeJump={incomeJump}
        />
      ) : null}
      {!isPending && !isError && !depositData ? (
        <Typography variant="body2" color="text.secondary">
          No bank activity details are available for this attempt yet.
        </Typography>
      ) : null}
    </ApplicationSectionCard>
  );
}
